<template>
    <!-- pricing Section -->
	<section class="price-sections">			
		<div class="container">
			<div class="row">
				<div class="col-md-12 text-center aos" data-aos="fade-up">
					<div class="section-heading sec-header">
						<h2>Pricing Plans</h2>
						<p>New service providers can test the platform.   </p>
					</div>
				</div>
			</div>
			<div class="price-toggle mb-0 text-center">
				<div class="status-toggle toggle-pink d-inline-flex align-items-center">
					Bill Monthly
					<input type="checkbox" id="status_1" class="check">
					<label for="status_1" class="checktoggle mx-3">checkbox</label>
					Bill Annualy
				</div>
			</div>
			<div class="row aos" data-aos="fade-up">
				<div class="col-lg-4 col-sm-12">
					<div class="pricing-plans price-new">
						<div class="pricing-planshead">
							<h6>$19<span>/month</span></h6>
							<h4>Starter</h4>
							<h5>Basic service description and up to 3 images</h5>
						</div>
						<div class="pricing-planscontent">
							<ul>
								<li>
									<i class="fa fa-check-circle me-2"></i>
									<span>Ability to list up to 3 services</span>
								</li>
								<li>
									<i class="fa fa-check-circle me-2"></i>
									<span>Access to buyer inquiries</span>
								</li>
								<li>
									<i class="fa fa-check-circle me-2"></i>
									<span>3% transaction fee on sales</span>
								</li>
								<li>
									<i class="fa fa-check-circle me-2"></i>
									<span>New service providers can test platform.</span>
								</li>
							</ul>
							<div class="pricing-btn">
								<router-link to="/service/search" class="btn btn-view">Choose Plan</router-link>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-4 col-sm-12">
					<div class="pricing-plans price-new active">
						<div class="pricing-planshead">
							<div class="price-block">
								<span class="popular">MOST POPULAR</span>
							</div>
							<h6>$89<span>/month</span></h6>
							<h4>Company</h4>
							<h5>Enhanced service description with video support</h5>
						</div>
						<div class="pricing-planscontent">
							<ul>
								<li>
									<i class="fa fa-check-circle me-2"></i>
									<span>Ability to list up to 10 services</span>
								</li>
								<li>
									<i class="fa fa-check-circle me-2"></i>
									<span>Up to 10 images per service</span>
								</li>
								<li>
									<i class="fa fa-check-circle me-2"></i>
									<span>Custom pricing for enterprise-level service</span>
								</li>
								<li>
									<i class="fa fa-check-circle me-2"></i>
									<span>3% transaction fee on sales</span>
								</li>
								<li>
									<i class="fa fa-check-circle me-2"></i>
									<span>New service providers can test the platform.</span>
								</li>
							</ul>
							<div class="pricing-btn">
								<router-link to="/service/search" class="btn btn-view">Choose Plan</router-link>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-4 col-sm-12">
					<div class="pricing-plans price-new">
						<div class="pricing-planshead">
							<h6>$150<span>/month</span></h6>
							<h4>Professional</h4>
							<h5>Advanced service with multiple media types</h5>
						</div>
						<div class="pricing-planscontent">
							<ul>
								<li>
									<i class="fa fa-check-circle me-2"></i>
									<span>Unlimited service listings</span>
								</li>
								<li>
									<i class="fa fa-check-circle me-2"></i>
									<span>Unlimited images per service</span>
								</li>
								<li>
									<i class="fa fa-check-circle me-2"></i>
									<span>Custom pricing for enterprise-level service</span>
								</li>
								<li>
									<i class="fa fa-check-circle me-2"></i>
									<span>2% transaction fee on sales</span>
								</li>
							</ul>
							<div class="pricing-btn">
								<router-link to="/service/search" class="btn btn-view">Choose Plan</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<!-- /pricing Section -->
	
	<!-- App Section -->
	<section class="app-section-two">
		<div class="container">
			<div class="row align-items-center">
				<div class="col-md-6 col-12">
					<div class="appimg aos" data-aos="fade-up">
						<img src="@/assets/img/mobile.svg" class="img-fluid" alt="img">
					</div>
				</div>
				<div class="col-md-6 col-12">	
					<div class="download-sec">
						<div class="section-heading-two">
							<p>Download App</p>
							<h2>We're available on mobile Just download it!</h2>
						</div>
						<div class="heading aos" data-aos="fade-up">
							<p>
								Whether you're looking to our app brings everything you need right
								to your fingertips.  Enjoy a smooth and intuitive experience designed
								with you in mind.
							</p>
							<h6>Scan the QR code to get the app now</h6>
							<div class="scan-img">
								<img src="@/assets/img/scan-img.png" class="img-fluid" alt="img">
							</div>
						</div>
						<div class="downlaod-btn aos" data-aos="fade-up">
							<a href="javascript:void(0);"><img src="@/assets/img/appstore.svg" alt="img"></a>
							<a href="javascript:void(0);"><img src="@/assets/img/googleplay.svg" alt="img"></a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<!-- /App Section -->
</template>